<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" role="doc-chapter">
<h1 class="h1chap"><span aria-label="8" epub:type="pagebreak" id="page_8" role="doc-pagebreak"><span aria-label="9" epub:type="pagebreak" id="page_9" role="doc-pagebreak">Chapter 1 <span class="heading_break">What Is Retirement?</span></span></span></h1>
<p class="noindent">Ask twenty people what retirement means, and you’ll get twenty different answers, but you’ll also hear some common themes. Retirement is about freedom and flexibility. It’s defined by being able to stop trading time for money, but it doesn’t mean you can’t work if you want to. Retirement puts you in charge of your time. That’s where retirement savings come in: To fund that phase of your life, you need to have access to a secure money supply.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?ad76b080